import React, { Component } from 'react';
import CertMoralFormModel from "../../models/certmoralform";
import {enumReferTypes, enumDeathLocation,enumWomanPrognancyStatus, identityCodeStatus,enumResidenceStatus,enumEducationStatus} from "../../constants/enum.constants";
import EnumRadioInput from "../../helpers/enumRadioInput";
import GeoLocation from "./geolocation";
import BDateInput from '../../helpers/bdate-input'
import moment from 'moment-jalaali';

import { userService } from "../../services";

import {
    Prompt
  } from "react-router-dom";


class CertReqMoralFormPartial extends Component {
    constructor(props) {
        super(props);
       
        this.state={
            model:new CertMoralFormModel(this.refs),
            isChanged:false
        }
        
          this.refreshModel=this.refreshModel.bind(this);
          this.refreshText=this.refreshText.bind(this);
          this.submit=this.submit.bind(this);  
          this.handlePersistentLocationCitySelectChange=this.handlePersistentLocationCitySelectChange.bind(this);
          this.handleDeathLocationCitySelectChange=this.handleDeathLocationCitySelectChange.bind(this);
          this.handleDeathDateChange=this.handleDeathDateChange.bind(this);
          this._handleKeyDown=this._handleKeyDown.bind(this);

     
    }

    _handleKeyDown(e) {
        console.log(e.keyCode);
        if (e.keyCode === 13) {
            const form = e.target.form;
            const index = Array.prototype.indexOf.call(form, e.target);
            form.elements[index + 1].focus();
            e.preventDefault();
        }

        if (e.keyCode === 40) {
            const form = e.target.form;
            const index = Array.prototype.indexOf.call(form, e.target);
            form.elements[index + 1].focus();
            e.preventDefault();
        }
        if (e.keyCode === 38) {
            const form = e.target.form;
            const index = Array.prototype.indexOf.call(form, e.target);
            form.elements[index - 1].focus();
            e.preventDefault();
        }
    }

    componentDidMount()
    {
        let model=new CertMoralFormModel(this.refs);


        this.setState({
            model:model
        })
        if(this.props.form!=null)
        {
            model=this.props.form;
            this.setState({
                model:model
            })
        }

        for (let x in this.refs) {

             this.refs[x].onkeydown = (e) => 
                 this._handleKeyDown(e, this.refs[x]);
               
        }

    }

    refreshModel (value=null,event) {
        var name=event.target.name;
       // let _model = new CertMoralFormModel(this.refs);  

        const {model}= this.state;
        model[name]=value;

        this.setState({

            model:model,
            isChanged:true

        });

        console.log('MODEL9',model);    
    }

    refreshText(event) {
        const {model}= this.state;
        var name=event.target.name;
        var value=event.target.value;
        model[name]=value;

        this.setState({

            model:model,
            isChanged:true

        });

        console.log('MODEL8',model);    
    }
    handlePersistentLocationCitySelectChange(item)
    {
       
        const{model}=this.state;
        if(model)
        {
            if(item)
            {
                model.PersistentLocationCityId=item.Id;
                model.HomeCode= item.County.Province.PhoneCode;

                model.DeathLocationCity=item;
                model.DeathLocationCityId=item.Id;

                this.setState({
                    model:model,
                    isChanged:true
                });
            }
        }
    }

    handleDeathLocationCitySelectChange(item)
    {
       
        const{model}=this.state;
        if(model)
        {
            if(item)
            {
                model.DeathLocationCityId=item.Id;
                model.DeathLocationCity=item;
                this.setState({
                    model:model,
                    isChanged:true
                });
            }
        }
    }

    handleDeathDateChange(e)
    {
        let datetime=this.refs.DeathTime.value;
        const{model}=this.state;
        if(model)
        {
               model.DeathTime=datetime;
                this.setState({
                    model:model,
                    isChanged:true
                });
            
        }
    }


    submit(){
        const {model}= this.state;

        let viewmodel= {
            Id:model.Id,
            FormType:1, // legal formtype,
            LegalForm: null,
            MoralForm:model
        }

        this.setState({
            isChanged:false
        })

        this.props.submitCertFormHandler(viewmodel);
      
      }


    render() { 


        const {form} = this.props;
        const {model,isChanged} = this.state;
        //console.log('MMMMODELLLLL',model)



        return (  

            <div>
                <form>
                                   
                <div className="row">
                    {/*
                <div className="col-md-12">
                    <div className="panel panel-default">
                        
                            <div className="toolbox">

                                <button type="button"  className="btn btn-success btn-sm" onClick={this.submit} ><i className="fa fa-save"></i>   ثبت اطلاعات
                                
                                </button>
                            
                            </div>
                    </div>
                </div>
                    */}
                <Prompt
                        when={isChanged}
                        message='اطلاعات وارد شده در فرم ذخیره نشده است، آیا تمایل به ترک فرم جاری را دارید؟'
                        
                    />

                    
                    <div className="col-md-6">
                    
                        <input type="hidden" value={form && form.Id}></input>
                        <fieldset><legend>مشخصات عمومی متوفی</legend>
                        <div className="form-group">
                                <label>
                                   وضعیت شناسنامه   &nbsp;
                                </label>
                                <EnumRadioInput enumObj={identityCodeStatus} value={model && model.IdentityCodeStatus} name="IdentityCodeStatus" ref="IdentityCodeStatus" onChange={this.refreshModel}></EnumRadioInput>
                        </div>
                        <div className="form-group">
                                <label>
                                   ملیت   &nbsp;
                                </label>
                                <EnumRadioInput enumObj={enumResidenceStatus} value={model && model.ResidenceStatus} name="ResidenceStatus" ref="ResidenceStatus" onChange={this.refreshModel}></EnumRadioInput>
                        </div>
                        <div className="form-group">
                                <label>
                                   شماره پروانه اقامت اتباع غیر ایرانی   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.ResidenceCodeNumber} ref="ResidenceCodeNumber"  name="ResidenceCodeNumber" onChange={this.refreshText} type="text" />
                        </div>
                        <div className="form-group">
                                <label>
                                   شغل   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.JobTitle} ref="JobTitle" name= "JobTitle"  type="text" onChange={this.refreshText} />
                        </div>
                        <div className="form-group">
                                <label>
                                   شماره ملی سرپرست خانوار   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.FamilyHeadNationalCode} ref="FamilyHeadNationalCode" name= "FamilyHeadNationalCode"  type="text" onChange={this.refreshText}/>
                        </div>
                        <div className="form-group">
                                <label>
                                   وضعیت سواد   &nbsp;
                                </label>
                                <EnumRadioInput enumObj={enumEducationStatus} value={model && model.EducationStatus}  name="EducationStatus" ref="EducationStatus" onChange={this.refreshModel}></EnumRadioInput>
                        </div>
                        </fieldset>
                        <fieldset><legend>آدرس محل سکونت دایمی متوفی</legend>
                            <div className="row">
                                <div className="col-md-6">
                                <div className="form-group">
                                   <GeoLocation value={model && model.PersistentLocationCity}  OnSelectChange={this.handlePersistentLocationCitySelectChange} {...this.props}></GeoLocation>
                                   <input  type="hidden" name="PersistentLocationCityId" ref="PersistentLocationCityId" value={model && model.PersistentLocationCityId}></input>
                                </div>
                                <div className="form-group">
                                    <label>
                                    بخش   &nbsp;
                                    </label>
                                    <input  className="form-control" value={model && model.CityDevision} ref="CityDevision" name= "CityDevision"  type="text" onChange={this.refreshText} />
                                </div>
                            <div className="form-group">
                                <label>
                                   روستا   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.CityVillage} ref="CityVillage" name= "CityVillage"  type="text" onChange={this.refreshText} />
                            </div>
                            <div className="form-group">
                                <label>
                                   خیابان   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.AddressStreet} ref="AddressStreet" name= "AddressStreet"  type="text" onChange={this.refreshText} />
                            </div>
                           
                                </div>
                                <div className="col-md-6">
                                <div className="form-group">
                                <label>
                                   کوچه   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.AddressAlley} ref="AddressAlley" name= "AddressAlley"  type="text" onChange={this.refreshText} />
                            </div>
                            <div className="form-group">
                                <label>
                                   پلاک   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.AddressHomeNo} ref="AddressHomeNo" name= "AddressHomeNo"  type="text" onChange={this.refreshText} />
                            </div>
                                <div className="form-group">
                                <label>
                                   کدپستی   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.PostalCode} ref="PostalCode" name= "PostalCode"  type="text" onChange={this.refreshText} />
                            </div>
                            <div className="form-group">
                                <label>
                                   تلفن ثابت   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.HomePhone} ref="HomePhone" name= "HomePhone"  type="text" onChange={this.refreshText} />
                            </div>
                            <div className="form-group">
                                <label>
                                   کد تلفن ثابت   &nbsp;
                                </label>
                                <input  className="form-control" value={model && model.HomeCode} ref="HomeCode" name= "HomeCode"  type="text" onChange={this.refreshText} />
                            </div>
                                </div>
                            </div>
                           
                           

                        </fieldset>
                        
                   
                    </div> 

                     <div className="col-md-6">
                     <fieldset><legend>اطلاعات مادر</legend>
                        <div className="form-group">
                                        <label>
                                        نام و نام خانوادگی مادر   &nbsp;
                                        </label>
                                        <input  className="form-control" value={model && model.MotherFullName} ref="MotherFullName"  name="MotherFullName"  type="text" onChange={this.refreshText}/>
                        </div>
                        <div className="form-group">
                                        <label>
                                        سن مادر   &nbsp;
                                        </label>
                                        <input  className="form-control" value={model && model.MotherAge} ref="MotherAge"  name="MotherAge"  type="text" onChange={this.refreshText}/>
                        </div>
                        <div className="form-group">
                                    <label>
                                    وضعیت سواد   &nbsp;
                                    </label>
                                    <EnumRadioInput enumObj={enumEducationStatus} value={model && model.MotherEducationStatus} name="MotherEducationStatus" ref="MotherEducationStatus" onChange={this.refreshModel}></EnumRadioInput>
                            </div>
                    </fieldset>
                    <fieldset><legend>آدرس محل فوت</legend>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <GeoLocation value={model && model.DeathLocationCity}  OnSelectChange={this.handleDeathLocationCitySelectChange} {...this.props}></GeoLocation>
                                        <input  type="hidden" name="DeathLocationCityId" ref="DeathLocationCityId" value={model && model.DeathLocationCityId}></input>
                                    </div>
                                    
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>
                                        بخش   &nbsp;
                                        </label>
                                        <input  className="form-control" value={model && model.DeathCityDevision} ref="DeathCityDevision" name= "DeathCityDevision"  type="text" onChange={this.refreshText} />
                                    </div>
                                    <div className="form-group">
                                        <label>
                                        روستا   &nbsp;
                                        </label>
                                        <input  className="form-control" value={model && model.DeathCityVillage} ref="DeathCityVillage" name= "DeathCityVillage"  type="text" onChange={this.refreshText} />
                                    </div>
                                </div>
                           </div>
                           <div className="form-group">
                                    <label>
                                    مکان فوت   &nbsp;
                                    </label>
                                    <EnumRadioInput enumObj={enumDeathLocation} value={model && model.DeathLocation} name="DeathLocation" ref="DeathLocation" onChange={this.refreshModel}></EnumRadioInput>

                            </div>
                            <div className="form-group">
                                    <label>
                                    سایر مکان فوت   &nbsp;
                                    </label>
                                    <input  className="form-control" value={model && model.DeathLocationOthers} ref="DeathLocationOthers" name= "DeathLocationOthers"  type="text" onChange={this.refreshText} />
                                    
                            </div>

                        </fieldset>
                        <fieldset><legend>بارداری زنان</legend>
                            <div className="form-group">
                                    <label>
                                    وضعیت بارداری زن   &nbsp;
                                    </label>
                                    <EnumRadioInput enumObj={enumWomanPrognancyStatus} value={model && model.WomanPrognancyStatus} name="WomanPrognancyStatus" ref="WomanPrognancyStatus" onChange={this.refreshModel}></EnumRadioInput>
                            </div>
                        
                        </fieldset>
                        
                        <fieldset><legend>تاریخ فوت</legend>
                            <div className="form-group">
                                    <label>
                                        تاریخ فوت
                                    </label>
                                
                                <BDateInput
                                    className="form-control"
                                    ref="DeathTime" 
                                    value={moment(model.DeathTime).isValid()?  model.DeathTime:moment() } 
                                    onChange={this.handleDeathDateChange}                               
                                />
                            </div>
                        </fieldset>
                        


                    </div>
                    
 
                            
                </div>
               
                <div className="col-md-12">
                        <fieldset><legend>علل فوت</legend>
                            <div className="col-md-8">

                                <div className="form-group">
                                            <label >
                                            الف) آخرین بیماری یا وضعیتی که منجر به فوت شده است:   &nbsp;
                                            </label>
                                            <input  className="form-control col-sm-12" value={model && model.DeathCause_A} ref="DeathCause_A" name= "DeathCause_A"  type="text" onChange={this.refreshText} />
                                </div>

                                <div className="form-group">
                                            <label >
                                            ب) بیماری یا وضعیتی که منجر به قسمت الف شده است:   &nbsp;
                                            </label>
                                            <input  className="form-control col-sm-12" value={model && model.DeathCause_B} ref="DeathCause_B" name= "DeathCause_B"  type="text" onChange={this.refreshText} />
                                </div>
                                <div className="form-group">
                                            <label >
                                            ج) بیماری یا وضعیتی که منجر به قسمت ب شده است:   &nbsp;
                                            </label>
                                            <input  className="form-control col-sm-12" value={model && model.DeathCause_C} ref="DeathCause_C" name= "DeathCause_C"  type="text" onChange={this.refreshText} />
                                </div>
                                <div className="form-group">
                                            <label >
                                            د) بیماری یا وضعیتی که منجر به قسمت ج شده است:   &nbsp;
                                            </label>
                                            <input  className="form-control col-sm-12" value={model && model.DeathCause_D} ref="DeathCause_D" name= "DeathCause_D"  type="text" onChange={this.refreshText} />
                                </div>

                                <div className="form-group">
                                            <label >
                                            ه) سایر وضعیت هایی که در وقوع مرگ موثر بوده اند امامنتج به علل اشاره شده در قمست (الف) نشده اند:   &nbsp;
                                            </label>
                                            <input  className="form-control col-sm-12" value={model && model.DeathCause_E} ref="DeathCause_E" name= "DeathCause_E"  type="text" onChange={this.refreshText} />
                                </div>
                                <div className="form-group">
                                            <label >
                                            و) سایر وضعیت هایی که در وقوع مرگ موثر بوده اند امامنتج به علل اشاره شده در قمست (الف) نشده اند:   &nbsp;
                                            </label>
                                            <input  className="form-control col-sm-12" value={model && model.DeathCause_F} ref="DeathCause_F" name= "DeathCause_F"  type="text" onChange={this.refreshText} />
                                </div>


                            </div>
                            <div className="col-md-4">
                                <div className="form-group" style={{paddingTop:43}}>
                                        
                                         
                                </div>
                                <div className="form-group">
                                            <label >
                                             فاصله زمانی تقریبی وضعیت (ب) تا مرگ :   &nbsp;
                                            </label>
                                            <input  className="form-control col-sm-12" value={model && model.DeathCause_Time_B} ref="DeathCause_Time_B" name= "DeathCause_Time_B"  type="text" onChange={this.refreshText} />
                                </div>
                                <div className="form-group">
                                            <label >
                                             فاصله زمانی تقریبی وضعیت (ج) تا مرگ :   &nbsp;
                                            </label>
                                            <input  className="form-control col-sm-12" value={model && model.DeathCause_Time_C} ref="DeathCause_Time_C" name= "DeathCause_Time_C"  type="text" onChange={this.refreshText} />
                                </div>
                                <div className="form-group">
                                            <label >
                                             فاصله زمانی تقریبی وضعیت (د) تا مرگ :   &nbsp;
                                            </label>
                                            <input  className="form-control col-sm-12" value={model && model.DeathCause_Time_D} ref="DeathCause_Time_D" name= "DeathCause_Time_D"  type="text" onChange={this.refreshText} />
                                </div>
                            </div>
                        </fieldset>
                        <div className="col-md-12">
                        <fieldset><legend>علت مراجعه</legend>
                            <EnumRadioInput enumObj={enumReferTypes}  name="enumReferType" ref="enumReferTypes" ></EnumRadioInput>
                        </fieldset>
                        </div>
                </div>

                <div className="col-md-12">
                    <div className="panel panel-default">
                        
                            <div className="toolbox">

                                <button type="button"  className="btn btn-success btn-sm" onClick={this.submit} ><i className="fa fa-save"></i>   ثبت اطلاعات
                                
                                </button>
                            
                            </div>
                    </div>
                </div>
               
                
                </form>  
               
            </div>
  
        );
    }
}
 
export default CertReqMoralFormPartial;